import moment from "moment";
function dateFormat(value) {
  let d = new Date(value);
  d.setHours(d.getHours() + 3);
  if (value) return moment(d).format("DD/MM/YYYY");
  else return "";
}

export default dateFormat;
